<div class="table-container" [ngStyle]="getContainerStyle()">
  <!-- Loading state -->
  <div *ngIf="loading" class="loading-state">
    <div class="loading-spinner"></div>
    <span>Loading...</span>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && data.length === 0" class="empty-state">
    <span>{{ emptyMessage }}</span>
  </div>

  <!-- Table -->
  <table *ngIf="!loading && data.length > 0" [class]="getTableClasses()">
    <thead>
      <tr>
        <th
          *ngFor="let column of columns"
          [ngStyle]="getColumnStyle(column)"
          [class.sticky-column]="column.sticky"
        >
          {{ column.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackByFn">
        <td
          *ngFor="let column of columns"
          [ngStyle]="getColumnStyle(column)"
          [class]="getCellClass(row, column)"
          [class.sticky-column]="column.sticky"
          [title]="getCellTooltip(row, column)"
        >
          {{ getCellDisplayValue(row, column) }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
